export const CSS_CLASSES = {
  RADIO_GROUP_ROOT_HORIZONTAL: "radio-group-root-horizontal",
  RADIO_GROUP_ROOT_VERTICAL: "radio-group-root-vertical",
  RADIO_GROUP_ROOT_FULL: "radio-group-root-full",
  RADIO_GROUP_ROOT_AUTO: "radio-group-root-auto",

  RADIO_GROUP_ROOT_JUSTIFY_START: "radio-group-root-justify-start",
  RADIO_GROUP_ROOT_JUSTIFY_END: "radio-group-root-justify-end",
  RADIO_GROUP_ROOT_JUSTIFY_CENTER: "radio-group-root-justify-center",
  RADIO_GROUP_ROOT_JUSTIFY_BETWEEN: "radio-group-root-justify-between",
  RADIO_GROUP_ROOT_JUSTIFY_AROUND: "radio-group-root-justify-around",
  RADIO_GROUP_ROOT_JUSTIFY_EVENLY: "radio-group-root-justify-evenly",

  RADIO_GROUP_FORM_FIELD_FULL: "radio-group-form-field-full",

  RADIO_GROUP_ITEM_HORIZONTAL: "radio-group-item-horizontal",
  RADIO_GROUP_ITEM_VERTICAL: "radio-group-item-vertical",
};
